import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    textStyle: {
      fontSize: 20,
      color: props.colors.cornflowerBlue,
      paddingRight: 8,
      ...props.typography.mulishBold,
    },
    touchableContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  });
